import {take, fork, put, select} from 'redux-saga/effects';
import {persistenceStates} from '@computerrock/formation-core';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as communicationActionTypes from '../communicationActionTypes';

const searchMessagesFlow = function* searchMessagesFlow() {
    const {serviceManager} = yield select(state => state.application);
    const leaAssignmentFlowService = serviceManager.loadService('leaAssignmentFlowService');

    while (true) {
        const {payload} = yield take(communicationActionTypes.SEARCH_MESSAGES);
        const searchQueryParams = new URLSearchParams();

        Object.keys(payload).forEach(key => {
            searchQueryParams.append(key, payload[key]);
        });

        yield put({
            type: communicationActionTypes.SET_MESSAGE_SEARCH_PERSISTENCE_STATE,
            payload: {newPersistenceState: persistenceStates.PENDING},
        });

        yield put({
            type: communicationActionTypes.RESET_MESSAGE_SEARCH_RESULTS,
            payload: null,
        });

        yield fork(
            fetchRequest,
            communicationActionTypes.SEARCH_MESSAGES_REQUEST,
            leaAssignmentFlowService.getMessages,
            {searchQueryParams},
        );

        const responseAction = yield take([
            communicationActionTypes.SEARCH_MESSAGES_REQUEST_SUCCEEDED,
            communicationActionTypes.SEARCH_MESSAGES_REQUEST_FAILED,
        ]);

        yield put({
            type: communicationActionTypes.SET_MESSAGE_SEARCH_PERSISTENCE_STATE,
            payload: {newPersistenceState: persistenceStates.READY},
        });

        if (responseAction.error) {
            yield put({
                type: communicationActionTypes.STORE_MESSAGE_SEARCH_ERROR,
                payload: {isMessageSearchError: true},
            });
            continue;
        }

        if (!responseAction.error) {
            const {response} = responseAction.payload;
            const {messageDTOs, total} = response;

            yield put({
                type: communicationActionTypes.STORE_MESSAGE_SEARCH_RESULTS,
                payload: {
                    pageNumber: payload['page'],
                    messagesSearchTotalCount: total,
                    messageDTOs,
                },
            });
            yield put({
                type: communicationActionTypes.STORE_MESSAGE_SEARCH_ERROR,
                payload: {isMessageSearchError: false},
            });
        }
    }
};

export default searchMessagesFlow;
